import { title } from "process";

const permissionsMasters = [
  {
    key: "USER_RIGHT_ENABLED",
    title: "Enable this account",
    pos: 1,
  },
  {
    key: "USER_RIGHT_PASSWORD",
    title: "Enable password change",
    pos: 2,
  },
  {
    key: "USER_RIGHT_OTP_ENABLED",
    title: "Enable one time password",
    pos: 3,
  },
  {
    key: "USER_RIGHT_RESET_PASS",
    title: "Change Password at next login",
    pos: 4,
  },
];

export { permissionsMasters };
